import themable from '_uikit/_themable'

export const Default = themable('ActivityDefaultTile')
export const FullBackground = themable('ActivityFullBackgroundTile')

export default { Default, FullBackground }
